import styles from 'src/components/BlogCategoryHeader/BlogCategoryHeader.module.scss'
import { Button } from 'src/components/Button/Button'
import { useLocale } from 'src/contexts/LocaleContext'
import { getMetafield } from 'src/functions/util/getMetafield'

import type { Collection } from 'src/data/graphql-generated'

interface CollectionLinksProps {
  subcollections: Collection[]
}

export const CollectionLinks = ({ subcollections }: CollectionLinksProps) => {
  const { language } = useLocale()

  return (
    <div className={styles.categories}>
      {subcollections.map((subcollection) => {
        const pageType = getMetafield(subcollection.metafields, 'layout', 'page_type')?.charAt(0) || 'c'

        return (
          <Button
            href={`/${language}/${pageType}/${subcollection.handle}`}
            key={`link-${subcollection.id}`}
            variant="secondary"
          >
            {subcollection.title}
          </Button>
        )
      })}
    </div>
  )
}
